import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Item, FormAddNew } from './Descuentos/Chunks';
import { Load, DeleteItem, Success, SearchBar } from './partials/PopUps.js';

class Descuentos extends React.Component{
   constructor(props){
      super(props);
      this.state = {
         show : false,
         modalNew : false,
         modalEdit : false,
         modalDelete : false,
         action : '',
			message : '',
         descuentos : [],
         display : {
            load : false,
            success : false
         },
         descuento : {
            id : '',
            codigo:'',
            porcentaje:'',
            condicion:'',
            cantidad : ''
         }
      };
      this.sesionShantal = JSON.parse( localStorage.getItem('sesion') );
   };
   componentDidMount(){
      fetch(window.$api+'/descuentos').then(res=>res.json()).then(
         success=>{
            const descuentos = success;
            const descuentosDefault = JSON.parse( JSON.stringify(descuentos));
            this.setState({descuentos, descuentosDefault})
         },
         error=>{
            console.log("ERROR :(");
         }
      )
   };
   getCodigo = () =>{
      let lastItem = this.state.descuentos.slice(-1);
      const codigo = Number(lastItem[0].codigo) + 1;
      return codigo < 10 ? ('0000'+codigo): '000'+codigo;
   }
   closeModalSuccess = (action) => {
      let display = {};
		switch(action){
			case 'delete':
				display = { success : !this.state.display.success }
				this.setState({display});
			break;
			case 'error' :
				display = { success : !this.state.display.success }
				this.setState({display});
			break;
			default:
				const descuento = {
               id : '',
               codigo:'',
               porcentaje:'',
               condicion:'',
               cantidad : ''
            };
				display = { success : !this.state.display.success }
				this.setState({descuento,display});
		}
	}
   searchHandler = (e) =>{
		let search = parseInt(e.target.value);
      if( isNaN(search) ){
         const descuentos = this.state.descuentosDefault;
         this.setState({descuentos});
      }else{
         let coleccion = JSON.parse(JSON.stringify(this.state.descuentosDefault));
         let descuentos = coleccion.filter(d=>parseInt(d.porcentaje)===search);
         this.setState({descuentos});
      }
   }
   inputHandler = (e) =>{
      const input = e.target;
      let descuento = this.state.descuento;
      descuento[input.name] = input.value;
      this.setState({descuento});
   }
   deleteItem = () =>{ 
      const id = this.state.descuento.id;
      const modalDelete = ! this.state.modalDelete;
      
      const display = { load : ! this.state.display.load };
      this.setState({display,modalDelete});
		fetch(window.$api+'/descuento/'+id,{method : 'DELETE'})
		.then(res=>res.json()).then(response=>{
         if( response.band === true ){
            const display = { load : !this.state.display.load };
            const descuento = {
               id : '',
               codigo:'',
               porcentaje:'',
               condicion:'',
               cantidad : ''
            };
            const descuentos = this.state.descuentos.filter(item=>item.id!==id);
            const descuentosDefault = JSON.parse( JSON.stringify(descuentos) );
            toast.success("Registro eliminado con éxito...");
            this.setState({display,descuentos,descuento,descuentosDefault});
         }
      });
   }
   submitNew = (e) =>{
      e.preventDefault();
      this.setState({display: { load : !this.state.display.load}});
      if( this.state.descuento.id === '' && 
         ( this.state.descuento.porcentaje && this.state.descuento.condicion )
      ){
         let config = {
            method : 'POST',
            body : JSON.stringify(this.state.descuento),
            headers : {'Content-Type': 'application/json'}
         };
         fetch( window.$api+'/descuento', config )
         .then(res=>res.json()).then(
            descuentos=>{
               const display = { load : !this.state.display.load };
               const modalNew = ! this.state.modalNew;
               const show = ! this.state.show;
               const descuentosDefault = descuentos;
               toast.success("Registro creado con éxito...");
               this.setState({show, modalNew, display, descuentos, descuentosDefault});
            },
            error=>{console.log(error)}
         );
      }else{
         if( Object.keys(this.state.descuento).length > 0 ){
            if( 
               this.state.descuento.cantidad !== '' &&
               this.state.descuento.porcentaje !== ''
            ){
               this.setState({display: { load : !this.state.display.load}});
               let config = {
                  method : 'PUT',
                  body : JSON.stringify(this.state.descuento),
                  headers : {'Content-Type': 'application/json'}
               };
               fetch(window.$api +'/descuento/'+this.state.descuento.id,config)
               .then(res=>res.json()).then(descuentos=>{
                  const descuentosDefault = descuentos;
                  const display = {load : !this.state.display.load };
                  const modalNew = ! this.state.modalNew;
                  const show = ! this.state.show;
                  toast.success('Registro actualizado con éxito...');
                  this.setState({show, modalNew, display, descuentos, descuentosDefault});
               });
               
            }else{
               this.setState({display: { load : this.state.display.load}});
               toast.warning("Hace falta información");
            }
         }else{
            this.setState({display: { load : ! this.state.display.load}});
            toast.warning("Formulario Vacio");
         }
      }
   }
   openAddNewModal = () => {
      const descuento = {
         id : '',
         codigo : 0,//this.getCodigo(),
         porcentaje :'',
         condicion :'',
         cantidad : ''
      };
      const modalNew = !this.state.modalNew;
      const show = !this.state.show;
      this.setState({modalNew,show,descuento});
   }
   closeModalDelete = () => {
      this.setState({ modalDelete : !this.state.modalDelete });
   }
   onEditModal = (id) => {
      const descuento = this.state.descuentos.find(e=>e.id===id );
      const modalNew = !this.state.modalNew;
      const show = !this.state.show;
      this.setState({modalNew,show,descuento});
   }
   onDeleteModal = (id) =>{
      const descuento = this.state.descuentos.find(e=>e.id===id);
      const modalDelete = ! this.state.modalDelete;
      this.setState({modalDelete, descuento});
   }
   render(){
      let listaDescuentos = [];
      if( this.state.descuentos.length > 0 ){
         this.state.descuentos.forEach((descuento, index)=>{
            listaDescuentos.push(
               <Item 
                  key={index}
                  sesion={this.sesionShantal}
                  descuento={descuento}
                  onEditModal={this.onEditModal}
                  onDeleteModal={this.onDeleteModal}
               />
            );
         })
      }
      return (
         <div className="wrap-module">
            <div className="menuProductos">
					<Link to="/productos" className="link-green"><i className="icon-right"></i></Link> 
					<Link to="/productos" className="">Productos</Link> / &nbsp;
               <h1 style={{display:'inline-block'}}>Descuentos</h1>
				</div>
				<div className="wrap-content">
               <SearchBar searchHandler={this.searchHandler} openModal={this.openAddNewModal} text={'descuento'}/>
					<table>
						<thead>
                     <tr>
                        <th>Porcentaje</th><th>Condición</th>
                        <th>Cantidad</th><th>Acciones</th>
                     </tr>
                  </thead>
						<tbody>
                     {listaDescuentos}
                  </tbody>
					</table>
				</div>
            <div className={this.state.show ? 'overlay show':'overlay'}>
               {
                  this.state.modalNew && 
                  <FormAddNew 
                     handler={this.inputHandler} 
                     close={this.openAddNewModal} 
                     descuento={this.state.descuento}
                     submit={this.submitNew}
                  />
               }
            </div>
            <Load display={this.state.display.load}></Load>
            <Success 
               display={this.state.display.success} 
               action={this.state.action}
               windowCloseUpdate={this.closeModalSuccess}
            />
            <DeleteItem 
               display={this.state.modalDelete}
               name={this.state.descuento.codigo}
               deleteItem={this.deleteItem}
               closeModalDelete={this.closeModalDelete}
            />
			</div>
		)
   }
}
export default Descuentos;